import React, { useEffect } from 'react';
import { getFramework, useIdentity } from '@/framework';
import ImageEffectAction from '@/layers/image-layer/utils/image-effect-action';
import { doImageEffect } from '@/layers/image-layer/utils/layer';
import { BaseLayerViewType, IExportPlugin, IImageLayerProps, PluginType } from '@/version-types';

/** 刷新图片蒙版特效 */
const RefreshImageMaskEffect: React.FC = React.memo(() => {
    const identity = useIdentity();
    const framework = getFramework(identity);

    useEffect(() => {
        const op = framework.events.onBaseOperate(async (layerId, operateType, args) => {
            const { isEnd, oldLayer } = args;
            // console.log('ot operateType', { isEnd, oldLayer });
            if (!isEnd || !oldLayer) return;
            if (
                operateType !== BaseLayerViewType.IMAGE_MOVE &&
                operateType !== BaseLayerViewType.IMAGE_ROTATE &&
                operateType !== BaseLayerViewType.IMAGE_SCALE
            )
                return;
            const layer = framework.getLayer(layerId);
            if (!layer) return;
            if (ImageEffectAction.isEmptyEffect(layer.data as IImageLayerProps)) {
                framework.history.write(oldLayer);
                return;
            }
            const result = await doImageEffect(identity, layerId);
            if (result) {
                framework.history.write(oldLayer);
            }
        });
        return () => {
            framework.events.off(op);
        };
    }, []);

    return null;
});

const exportPlugin: IExportPlugin = {
    type: PluginType.SYSTEM,
    sort: 1,
    name: 'image-mask-effect',
    render() {
        return <RefreshImageMaskEffect />;
    },
};

export default exportPlugin;
